/**
 * Enumerate message signature types.
 */
var MoneroMessageSignatureType;
(function (MoneroMessageSignatureType) {
    /**
     * Sign with spend key (value=0).
     */
    MoneroMessageSignatureType[MoneroMessageSignatureType["SIGN_WITH_SPEND_KEY"] = 0] = "SIGN_WITH_SPEND_KEY";
    /**
     * Sign with the view key (value=1).
     */
    MoneroMessageSignatureType[MoneroMessageSignatureType["SIGN_WITH_VIEW_KEY"] = 1] = "SIGN_WITH_VIEW_KEY";
})(MoneroMessageSignatureType || (MoneroMessageSignatureType = {}));
export default MoneroMessageSignatureType;
